'use client'

export const screenSizes = {
    DESKTOP: 1200,
    TABLET: 768,
    MOBILE: 576
}

export const medias = {
    LANDSCAPE: '(orientation: landscape) and (hover: none) and (pointer: coarse)',
    MOBILE: `/*(orientation: landscape) and (hover: none) and (pointer: coarse),*/ (max-width: ${screenSizes.MOBILE}px)`,
    TABLET: `/*((orientation: landscape) and (hover: none) and (pointer: coarse)) or*/ (max-width: ${screenSizes.TABLET}px)`,
    DESKTOP: `/*((orientation: landscape) and (hover: none) and (pointer: coarse)) or*/ (max-width: ${screenSizes.DESKTOP}px)`,
    '-TABLET': `/*((orientation: landscape) and (hover: none) and (pointer: coarse)) or*/ (min-width: ${screenSizes.TABLET + 1}px)`,
}
